<template>
	<v-layout row wrap>
	  <v-flex xs12>
		<v-card>
		  <v-card-text>
			<div
			  class="drop-area"
			  @dragover.prevent
			  @dragenter.prevent
			  @drop="handleDrop"
			  :style="{ pointerEvents: disable ? 'none' : 'auto' }"
			>
				<div v-if="disable" class="disabled-message">
					Función Inhabilitada. Ingrese el archivo o la url
				</div>
				<div v-else>
					<input
						type="file"
						ref="fileInput"
						style="display: none;"
						@change="handleFileChange"
						:multiple="multiple"
					/>
					<div class="image-button">
						<svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none">
							<path d="M15.1635 45.125C12.2769 45.125 9.81969 44.1068 7.79184 42.0706C5.76395 40.0344 4.75 37.5661 4.75 34.6658C4.75 31.8828 5.73729 29.4659 7.71186 27.4152C9.68648 25.3645 12.0044 24.2995 14.6656 24.2204C15.0919 20.6853 16.625 17.7462 19.2649 15.4032C21.9048 13.0602 25.0075 11.8887 28.5731 11.8887C32.4757 11.8887 35.7564 13.2713 38.415 16.0364C41.0736 18.8016 42.4029 22.1401 42.4029 26.0519V29.1211H43.8644C46.1968 29.0115 48.1775 29.7263 49.8065 31.2655C51.4355 32.8046 52.25 34.7495 52.25 37.1002C52.25 39.3138 51.4812 41.2047 49.9435 42.7728C48.4059 44.3409 46.5302 45.125 44.3166 45.125H30.875C29.9623 45.125 29.186 44.8051 28.5463 44.1653C27.9064 43.5254 27.5865 42.7492 27.5865 41.8365V26.6091L22.0646 32.1766L20.7447 30.9024L28.5 23.1471L36.2553 30.9024L34.9354 32.1766L29.4135 26.6091V41.8365C29.4135 42.2019 29.5657 42.5368 29.8702 42.8413C30.1747 43.1458 30.5096 43.298 30.875 43.298H44.2252C45.9456 43.298 47.4087 42.6927 48.6144 41.482C49.8202 40.2713 50.4231 38.8158 50.4231 37.1156C50.4231 35.4154 49.8202 33.9625 48.6144 32.7567C47.4087 31.5509 45.9402 30.948 44.2091 30.948H40.576V26.0519C40.576 22.6806 39.4014 19.7817 37.0523 17.3553C34.7031 14.9288 31.8356 13.7156 28.4498 13.7156C25.0639 13.7156 22.1864 14.9288 19.8175 17.3553C17.4486 19.7817 16.2642 22.6806 16.2642 26.0519H14.999C12.7276 26.0519 10.756 26.89 9.08438 28.5662C7.41273 30.2424 6.57691 32.2937 6.57691 34.72C6.57691 37.0671 7.41513 39.0835 9.09156 40.7693C10.768 42.4551 12.7919 43.298 15.1635 43.298H22.1971V45.125H15.1635Z" fill="#B8B8B8"/>
						</svg>
						<v-btn 
							class="upload-files"
							:disabled="disable"
							@click="openFileDialog">
							Examinar
						</v-btn>
					</div>
				</div>
			  	<p v-if="files.length === 0"></p>
				<ul v-else class="list">
					<li v-for="(file, index) in files" :key="index">
						<div class="file-item">
							<div class="file-info">
								<span>{{ file.name }}</span>
								<app-btn
									style="margin-left: 5px;"
									img="/static/img/close1.svg"
									text="Eliminar"
									@click-icon="removeFile(index)"
								/>
							</div>
							<v-progress-linear
								:value="file.progress"
								:color="file.progress === 100 ? 'green' : 'gray'"
								height="22"
								:indeterminate="file.progress < 100"
							><span class="progress-text">{{ file.progress }}%</span></v-progress-linear>
						</div>
					</li>
				</ul>
				<p v-if="!disable" class="text-drag">o arrastra un archivo hacia aquí</p>
			</div>
		  </v-card-text>
		</v-card>
	  </v-flex>
	</v-layout>
</template>
  
<script>

function validateFile(droppedFiles) {
	const validFiles = [];

	droppedFiles.forEach((file) => {
		const reader = new FileReader();

		reader.onload = (e) => {
			const arrayBuffer = e.target.result;
			const byteArray = new Uint8Array(arrayBuffer);
			const fileSignature = byteArray.slice(0, 4).join(' ');

			if (fileSignature === '37 80 68 70') {
				validFiles.push(file);
			} else {
				this.showNotification('Solo se permiten archivos PDF', 'warning');
			}

			if (validFiles.length === droppedFiles.length) {
				this.files = validFiles;
				this.uploadFiles();
			}
		};

		reader.readAsArrayBuffer(file);
	});
}

function handleDrop(event) {
	if (this.disable) return;
	event.preventDefault();
	const droppedFiles = Array.from(event.dataTransfer.files);
	this.validateFile(droppedFiles);
}

function handleFileChange(event) {
	if (this.disable) return;
	const droppedFiles = Array.from(event.target.files);
	this.validateFile(droppedFiles);
}

function openFileDialog() {
	this.$refs.fileInput.click();
}

function uploadFiles() {
	try {
		this.uploading = true;
		this.progress = 0;
		this.files.forEach((file) => {
			this.$set(file, 'progress', 0);
			this.$set(file, 'uploaded', false);
		});
		const totalFiles = this.files.length;
		let uploadedFiles = 0;

		this.files.forEach((file) => {
			const fileSize = file.size;
			const uploadSpeed = 100;
			const totalTime = fileSize / (uploadSpeed * 1000);
			const increment = 100 / (totalTime / 100);
			let progress = 0;

			const interval = setInterval(() => {
				if (progress < 100) {
					progress += increment;
					this.$set(file, 'progress', Math.min(progress, 100));
					this.$set(file, 'uploaded', true);
					this.$forceUpdate();
				} else {
					clearInterval(interval);
					uploadedFiles += 1;
					this.progress = (uploadedFiles / totalFiles) * 100;

					if (uploadedFiles === totalFiles) {
						this.uploading = false;
					}
				}
			}, 100);
		});
		this.$emit('upload-file', this.files);
	} catch (error) {
		this.showGenericError();
	}
}

function allFilesUploaded() {
	return this.files.every(file => file.uploaded);
}

function removeFile(index) {
	this.files.splice(index, 1);
}

function data() {
	return {
		files: [],
		uploading: false,
		progress: 0,
	};
}
export default {
	data,
	computed: {
		allFilesUploaded,
	},
	methods: {
		handleDrop,
		handleFileChange,
		openFileDialog,
		uploadFiles,
		validateFile,
		removeFile,
	},
	props: {
		multiple: {
			type: Boolean,
			default: false,
		},
		disable: {
			type: Boolean,
			default: false,
		},
		clean: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		clean: {
			handler(newVal, oldVal) {
				if (oldVal === false && newVal === true) {
					this.files = [];
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>
	.drop-area {
		border: 2px dashed #ccc;
		padding: 20px;
		text-align: center;
		cursor: pointer;
		.image-button {
			display: flex;
			flex-direction: column;
			align-items: center;
			.upload-files {
				width: 152px;
				height: 38px;
				flex-shrink: 0;
				border-radius: 3px;
				background: var(--maintitle, #55AC4B);
				color: var(--white, #FFF) !important;
				font-family: "Neuzeit Grotesk";
				font-size: 16px;
				font-style: normal;
				font-weight: 500;
				line-height: normal;
			}
		}
		.text-drag {
			color: var(--greyrborders, #B8B8B8);
			font-family: "Neuzeit Grotesk";
			font-size: 16px;
			font-style: normal;
			font-weight: 300;
			line-height: normal;
		}
		.file-item {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			margin-bottom: 10px;
		}
		  
		.file-info {
			display: flex;
			align-items: center;
			margin-bottom: 5px;
		}
		
		.file-info i {
			margin-right: 10px;
		}
		
		.v-progress-linear {
			width: 100%;
		}
		.progress-text {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			color: white;
			font-weight: bold;
		}
		.list {
			list-style-type: none;
			margin-top: 20px;
			
		}
		.disabled-message {
			color: red;
			font-weight: bold;
			text-align: center;
			margin: 10px 0;
		  }
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/drag-and-drop-file.vue